import React, { useState } from 'react';
import { CommonPageStep, ForgetPasswordPageStep } from '..';
import { isMobileOnly } from 'react-device-detect';
import { Navigate } from 'react-router-dom';
import { DesktopView } from './desktop/ForgetPassword.desktop';
import { MobileView } from './mobile/ForgetPassword.mobile';
import BblButton from '../../component/buttons/bblButton';
import { useAppSelector } from '../../store/hooks';
import {
  selectAppPageStep,
  setAppPageStep,
} from '../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../store/store';
import { GenericNotificationPage } from '../genericNotificationPage/genericNotificationPage';

export const SystemUpgradeResetPw = (): JSX.Element => {
  // Redux Hooks
  const appPageStep = useAppSelector(selectAppPageStep);
  const [landingPage, setLandingPage] = useState(true);

  React.useEffect(() => {
    outsideComponentDispatch(setAppPageStep(ForgetPasswordPageStep.SUBMIT));
  }, []);

  return (
    <React.Fragment>
      {landingPage ? (
        <GenericNotificationPage
          title={
            'Our system has been upgraded, please reset your password to continue.'
          }
          iconUrl={'assets/bigBangLab/reset-password.png'}
          button={
            <BblButton
              size="medium"
              color="primary"
              mute
              onClick={(): void => {
                setLandingPage(false);
              }}
            >
              Reset Password
            </BblButton>
          }
        />
      ) : isMobileOnly ? (
        <MobileView />
      ) : (
        <DesktopView />
      )}
    </React.Fragment>
  );
};
